<template>
    <b-container>
        <b-form @submit.prevent="doSearch" autocomplete="off">
            <b-row>
                <b-col xs="12">
                    <b-form-input
                        id="name"
                        type="text"
                        placeholder="Nombre"
                        v-model="name">
                    </b-form-input>
                </b-col>
            </b-row>

            <b-row class="mt-2">
                <b-col xs="12">
                    <b-form-input
                        id="surname"
                        type="text"
                        placeholder="Apellidos"
                        v-model="surname">
                    </b-form-input>
                </b-col>
            </b-row>

            <b-row class="mt-2">
                <b-col xs="12">
                    <b-form-input
                        id="phone"
                        type="number"
                        placeholder="Teléfono"
                        v-model="phone">
                    </b-form-input>
                </b-col>
            </b-row>

            <b-row class="mt-2">
              <b-col xs="12">
                <b-form-input
                  id="email"
                  type="email"
                  placeholder="Email"
                  v-model="email">
                </b-form-input>
              </b-col>
            </b-row>

            <b-row class="mt-2">
                <b-col xs="12" class="d-flex flex-row-reverse">
                    <button
                        type="submit"
                        class="btn btn-brand btn-primary"
                        :disabled="!validForm">
                        <i class="fa fa-search"></i>
                    </button>
                </b-col>
            </b-row>
        </b-form>

        <b-modal
            ref="clientSearchResults"
            hide-footer
            size="md"
            title="Resultados de la búsqueda"
            centered>
            <template v-if="!!clients && clients.length > 0">
                <b-list-group class="m-2">
                    <b-list-group-item
                        v-for="client in clients"
                        :key="client.uuid"
                        href="#"
                        class="d-flex justify-content-between align-items-center"
                        @click="submitClient(client)">
                        <div>{{ client.name }} {{ client.surname }}</div>
                        <div>
                            <small>{{ client.phone }}</small>
                        </div>
                    </b-list-group-item>
                </b-list-group>
            </template>
            <template v-else>
                <p class="my-3 text-center">
                    No hay resultados
                </p>
            </template>
        </b-modal>
    </b-container>
</template>

<script>
    import {searchClients} from '@/api/client-api';

    export default {
        name: "client-search-small",
        data: function () {
            return {
                name: null,
                surname: null,
                phone: null,
                email: null,
                clients: null
            };
        },
        computed: {
            validForm() {
                return (!!this.name || !!this.surname || !!this.phone || !!this.email)
            }
        },
        methods: {
            async doSearch() {
                if (this.validForm) {
                    this.$_loadingMixin_showLoading();
                    await searchClients({
                        name: this.name,
                        surname: this.surname,
                        phone: this.phone,
                        email: this.email
                    })
                        .then((clients) => {
                            if (clients.length === 1) {
                                this.submitClient(clients[0])
                            } else {
                                this.setUpSearchResults(clients);
                            }
                        })
                        .catch(() => {
                            this.setUpSearchResults([]);
                        });
                    this.$_loadingMixin_hideLoading();
                }
            },
            setUpSearchResults(clients) {
                this.$refs.clientSearchResults.show();
                this.clients = clients;
            },
            submitClient(client) {
                this.name = null;
                this.surname = null;
                this.phone = null;
                this.email = null;
                this.$refs.clientSearchResults.hide();
                this.$emit('submit-client', client);
            }
        }
    }
</script>

<style scoped>

</style>
